import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'
import api from 'api'

const FETCH_REQUEST = 'realhub/providerOrderCode/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/providerOrderCode/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/providerOrderCode/FETCH_FAILURE'

const CREATE_REQUEST = 'realhub/providerProductCode/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/providerProductCode/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/providerProductCode/CREATE_FAILURE'

const DELETE_REQUEST = 'realhub/providerProductCode/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/providerProductCode/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/providerProductCode/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loadedForEntities: [],
  loading: false,
  result: [],
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedForEntities: payload.loadedForEntities,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadProviderProductCodes(options){
  const { entityKey } = options || {}

  return (dispatch, getState) => {
    const loadedForEntities = [...getState().providerProductCodes.loadedForEntities]
    if (entityKey && !loadedForEntities.includes(entityKey)){
      loadedForEntities.push(entityKey)
    }

    dispatch(fetchRequest({ loadedForEntities }))

    const promise = api('/admin/provider_product_codes.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PROVIDER_PRODUCT_CODE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function createProviderProductCode(providerProductCode, options = {}, callback, errorCallback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      provider_product_code: providerProductCode,
    }),
  }
  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const url = `/admin/providers/${providerProductCode.provider_id}/provider_product_codes.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PROVIDER_PRODUCT_CODE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        if (errorCallback) errorCallback(errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function deleteProviderProductCode(providerProductCode, options = {}){
  const config = {
    method: 'DELETE',
    body: JSON.stringify({
      provider_product_code: providerProductCode,
    }),
  }
  return (dispatch) => {
    // Set Loading
    dispatch(deleteRequest())

    const { provider_id, id } = providerProductCode
    const url = `/admin/providers/${provider_id}/provider_product_codes/${id}.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PROVIDER_PRODUCT_CODE)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loadedForEntities: action.loadedForEntities || state.loadedForEntities,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
